<style>
/* .perizinan table{
    position: relative;
} */


/* .perizinan table tr td:first-child {
   position: sticky;
   left: 0;
   z-index: 2;
} */

/* .table > thead:first-child > tr:first-child > th:first-child {
    position: absolute;
    display: inline-block;
    background-color: red;
    height: 100%;
}

.table > tbody > tr > td:first-child {
    position: absolute;
    display: inline-block;
    background-color: red;
    height: 100%;
} */

/* .table > thead:first-child > tr:first-child > th:nth-child(2) {
    padding-left: 40px;
}

.table > tbody > tr > td:nth-child(2) {
    padding-left: 50px !important;
} */


/* .table td:nth-child(1) {
  position: absolute;
  width: 1px;
} */

/* .perizinan td, .perizinan th {
  border-bottom: dashed #888 1px;
} */


/* .perizinan table tr th:nth-child(2) {
  z-index: 11;
}

.perizinan table tr th:nth-child(17) {
  z-index: 11;
} */

/* .perizinan table tr th {
  top: 0;
  z-index: 9;
  background: red;
} */

/* table .dropdown-menu {
    position: fixed !important;
    top: 50% !important;
    left: 92% !important;
    transform: translate(-92%, -50%) !important;
} */

#berusahaPTSA_info,
#berusahaPTSA_paginate,
#berusahaPTSA_filter {
  display: none;
}
</style>
<template>
  <div>
    <div v-if="show" :show="show" class="text-center">
      <img :src="require('@/assets/loadingfish.gif')" alt="Loading..." width="150px" />
      <p id="cancel-label">Sedang memuat data...</p>

    </div>
    <div v-if="!show">
      <div class="d-flex justify-content-between">
        <div>
          <button type="button" class="btn btn-success" @click="exportData">
            <i class="fa fa-file-text-o"></i> Excel
          </button>
        </div>
        <div class="d-flex">
          <div class="d-flex">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mr-2 mb-0">Search: </label>
              <input v-model="search.value" type="text" class="form-control" id="search">
            </div>
            <div>
              <select v-model="search.field" class="form-control">
                <option value="nama_pemohon">Nama Pemohon</option>
                <option value="nomor_permohonan">Nomor Pemohon</option>
                <option value="jenis_kegiatan">Jenis Kegiatan</option>
                <option value="nama_perairan">Nama Perairan</option>
                <option value="lokasi">Provinsi</option>
                <!-- <option value="status_verdok">Status Verdok</option> -->
                <option value="status_permohonan">Status Permohonan</option>
                <option value="keterangan_status">Keterangan Status</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
                <option value="pic_name">PIC Pentek</option>
              </select>
            </div>
          </div>
          <div class="d-flex ml-4">
            <div class="d-flex align-items-center mr-2">
              <label for="search" class="mb-0">Sort By: </label>
            </div>
            <div>
              <select v-model="sort.field" class="form-control">
                <option value="createdAt">Tgl Submit</option>
                <option value="tanggal_pada_permohonan">Tgl Permohonan</option>
                <option value="tanggal_proses">Tgl Proses</option>
              </select>
            </div>
            <div class="ml-2">
              <select v-model="sort.direction" class="form-control">
                <option value="DESC">DESC</option>
                <option value="ASC">ASC</option>
              </select>
            </div>
          </div>
        </div>
      </div>
      <div class="table-responsive">
        <table id="berusahaPTSA" class="table" style="width:100%">
          <thead>
            <tr>
              <th>No</th>
              <th>Nama Pemohon</th>
              <th style="display:none">NIB</th>
              <th style="display:none">Nomor Proyek</th>
              <th style="display:none">KBLI</th>
              <th style="display:none">Jenis Proyek</th>
              <th style="display:none">Risiko</th>
              <th style="display:none">Skala Usaha</th>
              <th style="display:none">PIC Dokumen</th>
              <th>Nomor Pemohon</th>
              <th>Jenis Kegiatan</th>
              <th>Nama Perairan</th>
              <th>Provinsi</th>
              <!-- <th>Status Verdok</th> -->
              <th>Status Permohonan</th>
              <th>Keterangan Status</th>
              <th>Tgl. Permohonan</th>
              <th>Tgl. Proses</th>
              <th>Tgl. Berlaku Tagihan</th>
              <th>Status Tagihan</th>
              <th>PIC Pentek</th>
              <th>Unduh File</th>
              <!-- <th>File Surat Tugas</th>
                        <th>File Undangan</th>
                        <th>File BA</th>
                        <th>File Memo</th> -->
              <th class="all">Aksi</th>
            </tr>
            <!-- <tr>
            <th>Bukti Pembayaran</th>
            <th>Surat Tugas</th>
            <th>Undangan</th>
            <th>BA</th>
            <th>Memo</th>
            <th>Persetujuan</th>
          </tr> -->
          </thead>
          <tbody>
            <tr v-for="(row, index) in dataPermohonan" :key="index">
              <!-- <td :style="[row.prioritas ? {'color': 'green'} : {'color': 'black'}]" class="sticky-col first-col"></td> -->
              <td class="sticky-col second-col">
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  index + pagination.firstInPage }}</span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">{{
                    index + pagination.firstInPage }}</div>
                </span>
              </td>
              <td class="sticky-col second-col">
                <div v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <div style="width: 250px;" class="text-wrap">{{
                    row.nama_pemohon
                  }}</div>
                </div>
                <div v-else style="width: 250px;" class="text-wrap">
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    <div>{{ row.nama_pemohon }}</div>
                  </div>
                </div>
                <div v-if="row.tipe_permohonan == 'Multi KBLI' && row.tipe_multi_kbli == 'Mengikuti'"
                  class="text-secondary" style="font-size: 12px;">
                  Pendukung
                </div>
                <div v-else-if="row.tipe_permohonan == 'Multi KBLI' && row.tipe_multi_kbli == 'Proses'"
                  class="text-primary" style="font-size: 12px;">
                  Proses
                </div>
              </td>
              <td style="display: none">{{ row.nib_pemohon }}</td>
              <td style="display: none">{{ row.nomor_proyek }}</td>
              <td style="display: none">{{ row.kbli }}</td>
              <td style="display: none">{{ row.jenis_proyek }}</td>
              <td style="display: none">{{ row.risiko }}</td>
              <td style="display: none">{{ row.skala_usaha }}</td>
              <td style="display: none">{{ row.nama_pic_verdok }}</td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.nomor_permohonan
                }}</span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">{{ row.nomor_permohonan }}
                  </div>
                </span>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{ row.jenis_kegiatan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }, { 'width': '300px' }]">{{
                    row.jenis_kegiatan }}
                  </div>
                </div>
              </td>
              <td>
                <div class="text-wrap" v-if="row.status_verdok == 'Perbaikan Persyaratan'"
                  style="color: red;width: 300px;">{{ row.nama_perairan
                  }}</div>
                <div class="text-wrap" v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }, { 'width': '300px' }]">{{
                    row.nama_perairan }}
                  </div>
                </div>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.lokasi }}</span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">{{ row.lokasi }}</div>
                </span>
              </td>
              <!-- <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{
                  row.status_verdok
                  }}</span>
                <span v-else>
                  <div :style="[
                    row.prioritas ? { color: 'green' } : { color: 'black' },
                  ]">
                    {{ row.status_verdok }}
                  </div>
                </span>
              </td> -->
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.status_permohonan
                }}</span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">{{ row.status_permohonan
                  }}</div>
                </span>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">{{ row.keterangan_status
                }}</span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">{{ row.keterangan_status
                  }}</div>
                </span>
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_pada_permohonan) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                {{ format_date(row.tanggal_proses) }}
              </td>
              <td v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null &&
                  row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td v-else :style="[row.prioritas ? { color: 'green' } : { color: 'black' }]">
                <template v-if="row.status_tagihan_iii != null">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_iii) }}
                </template>
                <template v-else-if="
                  row.status_tagihan_ii != null && row.status_tagihan_i != null
                ">
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_ii) }}
                </template>
                <template v-else>
                  {{ format_date(row.tanggal_berlaku_hingga_tagihan_i) }}
                </template>
              </td>
              <td>
                <span v-if="row.status_verdok == 'Perbaikan Persyaratan'" style="color: red">
                  <span v-if="row.status_tagihan_iii != null">
                    {{ row.status_tagihan_iii }}
                  </span>
                  <span v-else-if="row.status_tagihan_ii != null && row.status_tagihan_i != null">
                    {{ row.status_tagihan_ii }}
                  </span>
                  <span v-else>
                    {{ row.status_tagihan_i }}
                  </span>
                </span>
                <span v-else>
                  <div :style="[row.prioritas ? { 'color': 'green' } : { 'color': 'black' }]">
                    <span v-if="row.status_tagihan_iii != null">
                      {{ row.status_tagihan_iii }}
                    </span>
                    <span v-else-if="row.status_tagihan_ii != null && row.status_tagihan_i != null">
                      {{ row.status_tagihan_ii }}
                    </span>
                    <span v-else>
                      {{ row.status_tagihan_i }}
                    </span>
                  </div>
                </span>

              </td>
              <td>
                {{ row.pic_name }}
              </td>
              <td>
                <FileDownload :row="row" />
              </td>

              <td v-if="row.tipe_multi_kbli == 'Mengikuti'">
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail" @click="
                  $router.push('/app/perizinan/detail-perizinan/' + row.id)
                  " class="text-white m-1"><i class="fa fa-eye" /> Detail</b-button>
              </td>
              <td v-else>
                <!-- <ul style="overflow:auto"> -->
                <!-- <b-dropdown variant="primary" split text="Aksi" class="me-3">
                          <b-dropdown-item  @click="$router.push('/app/perizinan/detail-perizinan/'+ row.id)">Detail</b-dropdown-item>
                          <b-dropdown-item v-if="row.tanggal_ttd_mkp === null" @click="getDetailPerDokumen(row.id, 'edit')">Edit</b-dropdown-item>
                          <b-dropdown-item v-if="row.tanggal_ttd_mkp === null" @click="deleteDokumen(row.id)">Delete</b-dropdown-item>
                          <b-dropdown-item v-if="row.paraf_1_memo_1_status === true" @click="getDetailPerDokumen(row.id, 'final')">Finalisasi</b-dropdown-item>
                        </b-dropdown> -->
                <b-button size="sm" variant="info" data-toggle="tooltip" data-placement="top" title="Detail"
                  @click="$router.push('/app/perizinan/detail-perizinan/' + row.id)" class="text-white"><i
                    class="fa fa-eye" />
                  Detail</b-button>

                <!-- </ul> -->
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="d-flex justify-content-between mt-4">
        <div>
          <template v-if="pagination.total">
            Menampilkan {{ pagination.firstInPage }} sampai {{ pagination.currentPage !== pagination.lastPage ?
              pagination.limit * pagination.currentPage : pagination.total }} dari {{ pagination.total }} data
          </template>
        </div>
        <nav aria-label="Page navigation example">
          <ul class="pagination">
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'first' })">
                <span aria-hidden="true">Awal</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === 1 }]">
              <a class="page-link" href="#" aria-label="Previous" @click="changePage({ option: 'prev' })">
                <span aria-hidden="true">Sebelumnya</span>
              </a>
            </li>
            <li v-for="i in pagination.pageNumber" class="page-item">
              <a :class="['page-link', { 'active': i === `${pagination.currentPage}` }]" href="#"
                @click="changePage({ page: i })">{{ i }}</a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'next' })">
                <span aria-hidden="true">Selanjutnya</span>
              </a>
            </li>
            <li :class="['page-item', { 'disabled': pagination.currentPage === pagination.lastPage }]">
              <a class="page-link" href="#" aria-label="Next" @click="changePage({ option: 'last' })">
                <span aria-hidden="true">Akhir</span>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>

    <!-- modal eddit -->
    <b-modal body-class="bg-white" id="modal-edit" title="Edit Verifikasi Dokumen" cancel-title="Close"
      ok-title="Accept" size="lg" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="6">
            <b-form-group label="Nama Pemohon: *">
              <b-form-input v-validate="'required'" name="Nama Pemohon"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Nama Pemohon') }" id="name" type="text"
                v-model="dataPerDokumen.nama_pemohon" />
              <span class="text-danger" v-if="errors.has('form-1.Nama Pemohon')">
                {{ errors.first('form-1.Nama Pemohon') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Nomor Permohonan: *">
              <b-form-input v-validate="'required'" name="Nomor Permohonan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Nomor Permohonan') }"
                v-model="dataPerDokumen.nomor_permohonan" type="text" />
              <span class="text-danger" v-if="errors.has('form-1.Nomor Permohonan')">
                {{ errors.first('form-1.Nomor Permohonan') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Email Pemohon: *">
              <b-form-input v-validate="'required'" name="Email Pemohon"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Email Pemohon') }"
                v-model="dataPerDokumen.email_pemohon" type="email" />
              <span class="text-danger" v-if="errors.has('form-1.Email Pemohon')">
                {{ errors.first('form-1.Email Pemohon') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="NPWP: *">
              <b-form-input v-validate="'required'" name="NPWP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.NPWP') }"
                v-model="dataPerDokumen.npwp_pemohon" type="text" v-mask="'##.###.###.#-###.####'" />
              <span class="text-danger" v-if="errors.has('form-1.NPWP')">
                {{ errors.first('form-1.NPWP') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="NIB: *">
              <b-form-input v-validate="'required'" name="NIB"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.NIB') }"
                v-model="dataPerDokumen.nib_pemohon" type="text" />
              <span class="text-danger" v-if="errors.has('form-1.NIB')">
                {{ errors.first('form-1.NIB') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="No Proyek: *">
              <b-form-input v-validate="'required'" name="No Proyek"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.No Proyek') }" type="text"
                v-model="dataPerDokumen.nomor_proyek" />
              <span class="text-danger" v-if="errors.has('form-1.No Proyek')">
                {{ errors.first('form-1.No Proyek') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="KBLI: *">
              <v-select id="default-select" v-model="dataPerDokumen.kbli" :options="[3112, 3113, 3114, 3116]"
                v-validate="'required'" name="KBLI" :class="{ 'is-invalid': errors.has('form-1.KBLI') }" />
              <span class="text-danger" v-if="errors.has('form-1.KBLI')">
                {{ errors.first('form-1.KBLI') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Tanggal Permohonan: *">
              <input type="date" v-validate="'required'" name="Tanggal Permohonan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Permohonan') }"
                v-model="dataPerDokumen.tanggal_pada_permohonan" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Permohonan')">
                {{ errors.first('form-1.Tanggal Permohonan') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Jenis Kegiatan: *">
              <b-form-input v-model="dataPerDokumen.jenis_kegiatan" type="text" v-validate="'required'"
                name="Jenis Kegiatan"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Jenis Kegiatan') }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Kegiatan')">
                {{ errors.first('form-1.Jenis Kegiatan') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Lokasi: *">
              <b-form-input type="text" v-validate="'required'" name="Lokasi"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Lokasi') }"
                v-model="dataPerDokumen.lokasi" />
              <span class="text-danger" v-if="errors.has('form-1.Lokasi')">
                {{ errors.first('form-1.Lokasi') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Jenis Proyek *">
              <v-select id="default-select" v-model="dataPerDokumen.jenis_proyek" label="nama"
                :reduce="jenis => jenis.nama" :options="dataJenisProyek" v-validate="'required'" name="Jenis Proyek"
                :class="{ 'is-invalid': errors.has('form-1.Jenis Proyek') }" />
              <span class="text-danger" v-if="errors.has('form-1.Jenis Proyek')">
                {{ errors.first('form-1.Jenis Proyek') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Risiko *">
              <v-select id="default-select" v-model="dataPerDokumen.risiko" label="nama" :reduce="risiko => risiko.nama"
                :options="dataRisiko" v-validate="'required'" name="Risiko"
                :class="{ 'is-invalid': errors.has('form-1.Risiko') }" />
              <span class="text-danger" v-if="errors.has('form-1.Risiko')">
                {{ errors.first('form-1.Risiko') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Skala Usaha *">
              <v-select id="default-select" v-model="dataPerDokumen.skala_usaha" label="nama"
                :reduce="skala => skala.nama" :options="dataSkalaUsaha" v-validate="'required'" name="Skala Usaha"
                :class="{ 'is-invalid': errors.has('form-1.Skala Usaha') }" />
              <span class="text-danger" v-if="errors.has('form-1.Skala Usaha')">
                {{ errors.first('form-1.Skala Usaha') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Luas (ha) *">
              <b-form-input min="0" step=".01" type="number" v-validate="'required'" name="Luas"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Luas') }"
                v-model="dataPerDokumen.luas" />
              <span class="text-danger" v-if="errors.has('form-1.Luas')">
                {{ errors.first('form-1.Luas') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Panjang *">
              <b-form-input min="0" step=".01" type="number" v-validate="'required'" name="Panjang"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Panjang') }"
                v-model="dataPerDokumen.panjang" />
              <span class="text-danger" v-if="errors.has('form-1.Panjang')">
                {{ errors.first('form-1.Panjang') }}
              </span>
            </b-form-group>
          </b-col>
          <!-- <b-col md="6">
                    <b-form-group label="Status Verifikasi Dokumen *">
                      <v-select
                        id="default-select"
                        v-model="dataPerDokumen.status_verdok"
                        label="nama"
                        :reduce="status => status.nama"
                        :options="dataStatusVerdok" 
                        v-validate="'required'" name="Status Verifikasi Dokumen"
                        :class="{  'is-invalid': errors.has('form-1.Status Verifikasi Dokumen') }"
                      />
                      <span class="text-danger" v-if="errors.has('form-1.Status Verifikasi Dokumen')">
                        {{ errors.first('form-1.Status Verifikasi Dokumen') }}
                      </span>
                    </b-form-group>
                </b-col> -->
          <b-col md="6">
            <b-form-group label="Tanggal Proses: *">
              <input type="date" v-validate="'required'" name="Tanggal Proses"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Proses') }"
                v-model="dataPerDokumen.tanggal_proses" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Proses')">
                {{ errors.first('form-1.Tanggal Proses') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="6">
            <b-form-group label="Pilih Admin: *">
              <v-select id="default-select" :reduce="admin => admin.id" label="nama" v-model="dataPerDokumen.id_admin"
                :options="dataUser" v-validate="'required'" name="Pilih Admin"
                :class="{ 'is-invalid': errors.has('form-1.Pilih Admin') }" />
              <span class="text-danger" v-if="errors.has('form-1.Pilih Admin')">
                {{ errors.first('form-1.Pilih Admin') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="Prioritas: *">
              <b-form-select v-model="dataPerDokumen.prioritas" v-validate="'required'" name="Prioritas"
                :class="{ 'is-invalid': errors.has('form-1.Prioritas') }" :options="optionsPrioritas"></b-form-select>
              <span class="text-danger" v-if="errors.has('form-1.Prioritas')">
                {{ errors.first('form-1.Prioritas') }}
              </span>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group label="PSN: *">
              <v-select id="default-select" v-model="dataPerDokumen.psn" :options="['PSN', 'Non PSN']"
                v-validate="'required'" name="PSN" :class="{ 'is-invalid': errors.has('form-1.PSN') }" />
              <span class="text-danger" v-if="errors.has('form-1.PSN')">
                {{ errors.first('form-1.PSN') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <div class="form-group">
              <b-form-group label="Catatan Untuk Pemohon: ">
                <ckeditor :editor="wygEditor" v-model="dataPerDokumen.catatan_verdok"></ckeditor>
              </b-form-group>
            </div>
          </b-col>
        </b-row>
      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="editData">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>

    <!-- modal finalisasi -->
    <b-modal body-class="bg-white" id="modal-finalisasi" title="Finalisasi Perizinan" cancel-title="Close"
      ok-title="Accept" cancel-variant="outline-secondary">
      <form ref="form" @submit.stop.prevent="tambahdata" data-vv-scope="form-1">
        <b-row>
          <b-col md="12">
            <b-form-group label="Nomor OSS: *">
              <b-form-input v-validate="'required'" name="Nomor OSS"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Nomor OSS') }" id="name" type="text"
                v-model="dataPerDokumen.nomor_oss" />
              <span class="text-danger" v-if="errors.has('form-1.Nomor OSS')">
                {{ errors.first('form-1.Nomor OSS') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tanggal Terbit OSS: *">
              <input type="date" v-validate="'required'" name="Tanggal Terbit OSS"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal Terbit OSS') }"
                v-model="dataPerDokumen.tanggal_terbit_oss" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal Terbit OSS')">
                {{ errors.first('form-1.Tanggal Terbit OSS') }}
              </span>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label="Tanggal TTD MKP: *">
              <input type="date" v-validate="'required'" name="Tanggal TTD MKP"
                :class="{ 'form-control': true, 'is-invalid': errors.has('form-1.Tanggal TTD MKP') }"
                v-model="dataPerDokumen.tanggal_ttd_mkp" />
              <span class="text-danger" v-if="errors.has('form-1.Tanggal TTD MKP')">
                {{ errors.first('form-1.Tanggal TTD MKP') }}
              </span>
            </b-form-group>
          </b-col>
        </b-row>
      </form>


      <template #modal-footer>
        <div class="w-100">
          <b-button variant="primary" style="float:right" @click="onFinalisasi">
            <i class="fa fa-floppy-o text-white" />

            <span class="text-white"> Simpan</span>
          </b-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>
<script src="https://cdn.datatables.net/fixedcolumns/4.1.0/js/dataTables.fixedColumns.min.js"></script>
<script>
import Vue from 'vue';
import moment from 'moment'
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import vSelect from 'vue-select';
import axios from 'axios';
import VueLoading from 'vuejs-loading-plugin'
import * as xlsx from "xlsx";
import FileDownload from "../../Components/FileDownload.vue";

// using default options
Vue.use(VueLoading)

// overwrite defaults
Vue.use(VueLoading, {
  dark: true, // default false
  text: 'Loading', // default 'Loading'
  loading: true, // default false
  //customLoader: myVueComponent, // replaces the spinner and text with your own
  background: 'rgb(255,255,255)', // set custom background
  classes: ['myclass'] // array, object or string
})
export default {
    components: {ClassicEditor, vSelect, FileDownload},
    data() {
        return {
            fields: [
                { key:'no'},
                { key: "nama_pemohon", sortable: true },
                { key: "nomor_permohonan", sortable: true },
                { key: "jenis_kegiatan", sortable: true },
                { key: "status_verdok", label: "Status Verdok", sortable: true },
                { key: "status_vertek", label: "Status Pentek", sortable: true },
                { key: "tanggal_pada_permohonan", label: "Tanggal Permohonan" },
                { key: "file_undangan", label: 'Undangan Pentek'},
                { key: "file_ba", label: "File BA" },
                { key: "file_memo", label: "File Memo" },
                'Aksi'
            ],
            optionsDatatable: {
                perPage: 10,
                pagination: { chunk: 10, dropdown: false },
                texts: { filter: '', count: '', limit: '' },
                columnsClasses: { id: 'width-100'},
                skin: 'table table-striped',
                sortIcon: {
                    base: 'fa text-muted', up: 'fa-chevron-up', down: 'fa-chevron-down', is: 'fa-sort',
                },
            },

            // currentPage: 1,
            perPage: 10,
            pageOptions: [10, 25, 50, 100],
            filter: null,
            filterOn: [],
            sortBy: "name",
            sortDesc: false,
            dataPerDokumen: [],
            wygEditor: ClassicEditor,
            dataRoles: [],
            dataPermohonan: [],
            dataUser: [],
            optionsPrioritas: [
              { value: true, text: 'Ya' },
              { value: false, text: 'Tidak' },
            ],
            selectedFile: null,
            optionsFile: [
              { value: null, text: '- Unduh file -' },
              { value: 'tagihan', text: 'Tagihan' },
              { value: 'pembayaran', text: 'Bukti Pembayaran' },
              { value: 'surattugas', text: 'Surat Tugas' },
              { value: 'undangan', text: 'Undangan' },
              { value: 'ba', text: 'Berita Acara' },
              { value: 'memo', text: 'Memo' },
              { value: 'persetujuan', text: 'Persetujuan' },
            ],

            pagination: {
              currentPage: parseInt(this.$route.query.page) || 1,
              lastPage: null,
              pageNumber: [],
              limit: 0,
              total: 0,
              firstInPage: 0,
            },
            search: {
              field: "nama_pemohon",
              value: "",
            },
            sort: {
              field: "createdAt",
              direction: "DESC",
            },
            debounceTerm: null,
            show: false,
        }
    },
    props: {
        itemsWithNumber: {
            type: Array,
                default: () => {
                    return [];
                },
        },
        dataJenisProyek: {
            type: Array,
                default: () => {
                    return [];
                },
        },
        user: {
            // type: Array,
                default: () => {
                    return [];
                },
        },
        baseapi: String,
        dataRisiko: {
            type: Array,
                default: () => {
                    return [];
                },
        },
        dataSkalaUsaha: {
            type: Array,
                default: () => {
                    return [];
                },
        },
        dataStatusVerdok: {
            type: Array,
                default: () => {
                    return [];
                },
        },
        rows: Number,

        totalRows: Number,
        currentPage: Number,
    },
    methods: {
        onFiltered(data){
            this.$emit('onFiltered', data)
        },
        format_date(value){
          if (value) {
            return moment(String(value)).format('DD MMMM YYYY')
            }
        },

        getDataUser() {
          axios.get(this.baseapi + 'api/user?filter=role,=,admin_kkp', {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }).then(response => {
            this.dataUser = response.data.data;
          }).catch(error => {
            console.log(error)
            return error
          });
        },

        pilihModal(data){
            this.$emit('pilihModal', data)
            // this.getdata()
        },

        deleteDokumen(data){
            this.$emit('deleteDokumen', data)
            this.getdata()
        },

        // format_date(value){
        //   if (value) {
        //     return moment(String(value)).format('DD-MM-YYYY')
        //     }
        // },

        async getdata(){
          $('#berusahaPTSA').DataTable().destroy();
          await this.loaddata()
        },

        loaddata() {
          this.show = true
          this.dataPermohonan = []
          // var api;
          // if (this.user.role == 'pic') {
          //   api = 'api/permohonan?filter=pic_id,=,'+this.user.id
          // } else if (this.user.role == 'admin_kkp'){
          //   api = 'api/permohonan?filter=id_admin,=,'+this.user.id
          // } else {
          //   api = 'api/permohonan'
          // }
          // const api = `api/permohonan/dataTable?page=${this.pagination.currentPage}${this.search.value ? `&filter=${this.search.field},like,${this.search.value}` : ''}`
          const api = `api/permohonan/dataTable`+
            `?page=${this.pagination.currentPage}`+
            `${this.search.value!==''?`&filter=${this.search.field},${this.search.field==='tanggal_proses'||this.search.field==='tanggal_pada_permohonan'?'>=':'like'},${this.search.value}`:''}`+
            `&sort=${this.sort.field},${this.sort.direction}`
          return axios.get(this.baseapi + api, {
            headers: {
              Authorization: `Bearer ` + this.user.accessToken
            }
          }).then(response => {
            const data = response.data
            this.pagination.limit = data.limit
            this.pagination.total = data.total
            this.pagination.firstInPage = (this.pagination.currentPage - 1) * data.limit + 1
            this.pagination.lastPage = Math.ceil(data.total/data.limit)
            this.setPagination()
            this.dataPermohonan = response.data.data;

            for (let index = 0; index < this.dataPermohonan.length; index++) {
              Vue.set(this.dataPermohonan[index], 'selectedFile', null); 
              
            }
            this.initDatatable();
          }).catch(error => {
            console.log(error)
            return error
          }).finally(() => {
            this.show = false
          });
        },

        setPagination() {
          this.$router.replace({
            path: this.$route.path,
            query: { page: this.pagination.currentPage },
          }).catch((err) => {})
          this.pagination.pageNumber = []
          if (this.pagination.lastPage > 7) {
            if (this.pagination.currentPage <= 4) {
              this.pagination.pageNumber.push('1')
              this.pagination.pageNumber.push('2')
              this.pagination.pageNumber.push('3')
              this.pagination.pageNumber.push('4')
              this.pagination.pageNumber.push('5')
            } else if (this.pagination.currentPage >= this.pagination.lastPage-2) {
              this.pagination.pageNumber.push('1')
              this.pagination.pageNumber.push('...')
              this.pagination.pageNumber.push(`${this.pagination.lastPage-4}`)
              this.pagination.pageNumber.push(`${this.pagination.lastPage-3}`)
              this.pagination.pageNumber.push(`${this.pagination.lastPage-2}`)
            } else {
              this.pagination.pageNumber.push('1')
              this.pagination.pageNumber.push('...')
              this.pagination.pageNumber.push(`${this.pagination.currentPage-1}`)
              this.pagination.pageNumber.push(`${this.pagination.currentPage}`)
              this.pagination.pageNumber.push(`${this.pagination.currentPage+1}`)
            }
            if (this.pagination.currentPage >= this.pagination.lastPage-2) {
              this.pagination.pageNumber.push(`${this.pagination.lastPage-1}`)
              this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
            } else {
              this.pagination.pageNumber.push('...')
              this.pagination.pageNumber.push(`${this.pagination.lastPage}`)
            }
          } else {
            for (let i=1; i<=this.pagination.lastPage; i++) {
              this.pagination.pageNumber.push(`${i}`)
            }
          }
        },

        async changePage(config = {option: 'next', page: null}) {
          if (config.option === 'next') {
            if (this.pagination.currentPage < this.pagination.lastPage) {
              this.pagination.currentPage++
            }
          }
          if (config.option === 'prev') {
            if (this.pagination.currentPage > 1) {
              this.pagination.currentPage--
            }
          }
          if (config.option === 'first') {
            this.pagination.currentPage = 1
          }
          if (config.option === 'last') {
            this.pagination.currentPage = this.pagination.lastPage
          }
          if (config.page) {
            if(config.page === '...') return
            this.pagination.currentPage = parseInt(config.page)
          }
          this.setPagination()
          await this.getdata()
          $('html,body').scrollTop(1000)
        },

        initDatatable() {
          $.fn.dataTable.moment("DD MMMM YYYY");
            setTimeout(() => {
              // const screenWidth = window.innerWidth;
              // const hasFixedColumns = screenWidth > 600;
              // const fixedColumnsConfig = hasFixedColumns ? { left:2, right: 1} : null;

              // if ($.fn.DataTable.isDataTable("#example")) {
              //   $("#example").DataTable().destroy();
              // }
            var t =  $('#berusahaPTSA').DataTable({
                "pagingType": "full_numbers",
                "language": {
                    "info": "Menampilkan _START_ sampai _END_ dari _TOTAL_ data",
                    "paginate": {
                        "first":      "Awal",
                        "last":       "Akhir",
                        "next":       "Selanjutnya",
                        "previous":   "Sebelumnya"
                    },
                },
                // stateSave: true,
                // order: [[0, 'desc']],
                responsive: true,
                destroy: true,
                retrieve: true,
                autoFill: true,
                colReorder: true,
                fixedColumns:   { left:2, right: 1},
                scrollX: true,
                dom: 'Bfrtip',
                // "fnRowCallback": function(nRow, aData, iDisplayIndex, iDisplayIndexFull) {
                //     //debugger;
                //     var index = iDisplayIndexFull + 1;
                //     $("td:first", nRow).html(index);
                //     return nRow;
                //   },
                  columnDefs: [{
                    targets: 0,
                    render: function(data, type, row, meta) {
                    // console.log(meta.row);
                    // console.log(type == 'export'? meta.row : data);
                      return type == 'export'? meta.row + 1 : data;
                    }
                  }],
                  buttons: [
                    // 'excel', 'pdf',
                    // {
                    //   extend: 'excelHtml5',
                    //     title: 'DATA PEMOHON',
                    //     text : '<i class="fa fa-file-text-o"></i> Excel',
                    //     className: 'btn btn-success',
                    //     exportOptions: {
                    //       columns: [0,15,1, 2,9,3, 4, 5, 6, 7,11,12, 8],
                    //         orthogonal: 'export',
                    //         // format: {
                    //         //     header: function ( data, columnIdx ) {
                    //         //         if(columnIdx==7 || columnIdx==8 || columnIdx==9){
                    //         //         return 'Aktivitas ' + data;
                    //         //         }
                    //         //         else if(columnIdx==10 || columnIdx==11){
                    //         //           return 'Verifikasi Dokumentatif ' + data;
                    //         //         }
                    //         //         else if(columnIdx==12 || columnIdx==13){
                    //         //           return 'Verifikasi Lapangan ' + data;
                    //         //         }
                    //         //         else if(columnIdx==14 || columnIdx==15){
                    //         //           return 'File BA ' + data;
                    //         //         }
                    //         //         else if(columnIdx==16 || columnIdx==17 || columnIdx==18){
                    //         //           return 'Predikat ' + data;
                    //         //         }
                    //         //         else{
                    //         //           return data;
                    //         //         }
                    //         //     },
                    //         //     body: function(data, row, column, node) {
                    //         //         data = $('<p>' + data + '</p>').text();
                    //         //         return data.replace(',', '.');
                    //         //     },
                    //         // }
                    //     },
                    //     filename: function(){
                    //         var today = new Date();
                    //         // var n = d.getTime();
                    //         var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
                            
                    //         return 'Data Pemohon ' + date;
                    //     },
                    // },
                ],

            });
            // if(hasFixedColumns){
            //   t.fixedColumns().update();
            // }else{
            //   const $actionColumn = $('#example th:last-child');
            //   $actionColumn.removeClass('dtfc-fixed-right');
            //   $actionColumn.css('position', '');
            // }
            // t.on( 'order.dt search.dt', function () {
            // t.column(0, {search:'applied', order:'applied'}).nodes().each( function (cell, i) {
            //     cell.innerHTML = i+1;
            // } );
            // } ).draw();
            }, 300)
        },

        getDetailPerDokumen(id, modal){
          axios.get(this.baseapi + "api/permohonan/" + id, {
              headers: {
                Authorization: `Bearer ` + this.user.accessToken
              }
            }).then(response => {
              this.dataPerDokumen = response.data.data;
              if (modal === 'edit') {
                this.$bvModal.show('modal-edit')
              } else {
                this.$bvModal.show('modal-finalisasi')
              }
            }).catch(error => {
              console.log(error)
              return error
            });
        },

        editData() {
          this.$validator.validateAll('form-1').then((result) => {
            if (result) {
              axios.post(this.baseapi + 'api/permohonan/'+ this.dataPerDokumen.id, {
                nib_pemohon: this.dataPerDokumen.nib_pemohon,
                nama_pemohon: this.dataPerDokumen.nama_pemohon,
                email_pemohon: this.dataPerDokumen.email_pemohon,
                npwp_pemohon: this.dataPerDokumen.npwp_pemohon,
                tanggal_pada_permohonan: this.dataPerDokumen.tanggal_pada_permohonan,
                tangal_masuk_oss: this.dataPerDokumen.tanggal_proses,
                nomor_permohonan: this.dataPerDokumen.nomor_permohonan,
                nomor_proyek: this.dataPerDokumen.nomor_proyek,
                kbli: this.dataPerDokumen.kbli,
                jenis_kegiatan: this.dataPerDokumen.jenis_kegiatan,
                lokasi: this.dataPerDokumen.lokasi,
                jenis_proyek: this.dataPerDokumen.jenis_proyek,
                risiko: this.dataPerDokumen.risiko,
                skala_usaha: this.dataPerDokumen.skala_usaha,
                luas: this.dataPerDokumen.luas,
                panjang: this.dataPerDokumen.panjang,
                pic: this.dataPerDokumen.pic,
                status_verdok: this.dataPerDokumen.status_verdok,
                tanggal_proses: this.dataPerDokumen.tanggal_proses,
                catatan_verdok: this.dataPerDokumen.catatan_verdok,
                prioritas: this.dataPerDokumen.prioritas,
                id_admin: this.dataPerDokumen.id_admin,
                npwp_pemohon: this.dataPerDokumen.npwp_pemohon,
                psn: this.dataPerDokumen.psn,
              },{
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken
                }
              })
                .then((res) => {
                  this.$toasted.success("Berhasil Diubah");
                  // this.$emit('loaddata')
                  this.getdata()
                  this.dataPerDokumen = []

                  // Wait until the models are updated in the UI
                  this.$nextTick(() => {
                    this.$bvModal.hide('modal-edit')
                  });
                  return res;
                })
                .catch((err) => {
                  console.log(err)
                  this.$toasted.error(err.response.data.message);
                  return err;
                });
            }
          })
        },

        onFinalisasi() {
          this.$validator.validateAll('form-1').then((result) => {
            if (result) {
              this.$nextTick(() => {
                    this.$bvModal.hide('modal-finalisasi')
                  });
              this.$loading(true);
              axios.post(this.baseapi + 'api/permohonan/'+ this.dataPerDokumen.id, {
                tanggal_ttd_mkp: this.dataPerDokumen.tanggal_ttd_mkp,
                nomor_oss: this.dataPerDokumen.nomor_oss,
                tanggal_terbit_oss: this.dataPerDokumen.tanggal_terbit_oss,
              }, {
                headers: {
                  "Content-type": "application/json",
                  Authorization: `Bearer ` + this.user.accessToken
                }
              })
                .then((res) => {
                  this.$loading(false);
                  this.$toasted.success("Berhasil Disimpan");
                  // this.$emit('loaddata')
                  this.getdata()
                  this.dataPerDokumen = []

                  // Wait until the models are updated in the UI
                  // this.$nextTick(() => {
                  //   this.$bvModal.hide('modal-finalisasi')
                  // });
                  return res;
                })
                .catch((err) => {
                  this.$loading(false);
                  console.log(err)
                  this.$toasted.error(err.response.data.message);
                  return err;
                });
            }
          })
        },

       exportData() {
      this.$loading(true);
      const api = `api/permohonan` +
        `?sort=${this.sort.field},${this.sort.direction}` +
        `${this.search.value !== '' ? `&filter=${this.search.field},${this.search.field === 'tanggal_proses' || this.search.field === 'tanggal_pada_permohonan' ? '>=' : 'like'},${this.search.value}` : ''}`

      axios.get(this.baseapi + api, {
        headers: {
          Authorization: `Bearer ` + this.user.accessToken
        }
      }).then((res) => {
        const worksheetData = [
          ['Data Pemohon'],
          ['No', 'Prioritas', 'Nama Pemohon', 'Nomor Pemohon', 'Jenis Kegiatan', 'Nama Perairan', 'Provinsi', 'Status Verdok', 'Status Pentek', 'Tgl. Permohonan', 'Tgl. Proses', 'Tgl. Berlaku Tagihan', 'Status Tagihan', 'PIC Pentek'],
        ]
        const merge = [{ s: { c: 0, r: 0 }, e: { c: worksheetData[1].length - 1, r: 0 } }]

        res.data.data.forEach((d, i) => {
          worksheetData.push([
            i + 1,
            d.prioritas ? 'Prioritas' : '',
            d.nama_pemohon,
            d.nomor_permohonan,
            d.jenis_kegiatan,
            d.nama_perairan,
            d.lokasi,
            d.status_verdok,
            d.status_vertek,
            d.tanggal_pada_permohonan,
            d.tanggal_proses,
            d.tanggal_berlaku_hingga_tagihan_iii
              ? d.tanggal_berlaku_hingga_tagihan_iii
              : d.tanggal_berlaku_hingga_tagihan_ii
              ? d.tanggal_berlaku_hingga_tagihan_ii
              : d.tanggal_berlaku_hingga_tagihan_i
              ? d.tanggal_berlaku_hingga_tagihan_i
              : '',
            d.status_tagihan_iii
              ? d.status_tagihan_iii
              : d.status_tagihan_ii
              ? d.status_tagihan_ii
              : d.status_tagihan_i
              ? d.status_tagihan_i
              : '',
            d.pic_name,
          ])
        })

        const workbook = xlsx.utils.book_new();
        const worksheet = xlsx.utils.aoa_to_sheet(worksheetData);
        worksheet["!merges"] = merge;
        xlsx.utils.book_append_sheet(workbook, worksheet, "Sheet1");

        const d = new Date();
        xlsx.writeFile(workbook, `Data Pemohon ${d.getFullYear()}-${d.getMonth() + 1}-${d.getDate()}.xlsx`);
      }).catch((err) => {
        Swal.fire('Gagal', 'Gagal mengekspor data', 'error')
      }).finally(() => {
        this.$loading(false);
      })
    }
    },
    mounted() {
        this.getdata()
        this.getDataUser()
        // this.initDataTable();     
        // $(window).on("resize", this.initDataTable);
    },
    // beforeDestroy() {
    //   $(window).off("resize", this.initDataTable);
    // if ($.fn.DataTable.isDataTable("#example")) {
    //   $("#example").DataTable().destroy();
    // }
    // },
    watch: {
      search: {
        handler: function (val) {
          if (this.debounceTerm) {
            clearTimeout(this.debounceTerm)
          }
          this.debounceTerm = setTimeout(() => {
            this.pagination.currentPage = 1
            this.getdata();
          }, 1000)
        },
        deep: true,
      },
      sort: {
        handler: function (val) {
          this.pagination.currentPage = 1
          this.getdata();
        },
        deep: true,
      },
    },
}
</script>